import { render, staticRenderFns } from "./myshare.vue?vue&type=template&id=6ad625a8&scoped=true"
import script from "./myshare.vue?vue&type=script&lang=js"
export * from "./myshare.vue?vue&type=script&lang=js"
import style0 from "./myshare.vue?vue&type=style&index=0&id=6ad625a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad625a8",
  null
  
)

export default component.exports